import { apiClient } from "./apiClient";

const auth = (accessToken) => ({ headers: { Authorization: `Bearer ${accessToken}` } });

// Paginated -> {items, total} (total from X-Total-Count).
export const listSshGrants = async (accessToken, params) => {
  const res = await apiClient.get("/admin/ssh-access/grants", { ...auth(accessToken), params });
  return { items: res.data, total: Number(res.headers?.["x-total-count"] ?? res.data.length) };
};

export const createSshGrant = (accessToken, payload) =>
  apiClient.post("/admin/ssh-access/grants", payload, auth(accessToken));
